var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrlDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.955,31a8.466,8.466,0,0,1-2.47,6.515l-5,5a8.485,8.485,0,0,1-12,0h0a8.485,8.485,0,0,1,0-12l5-5A8.466,8.466,0,0,1,17,23.045",
    fill: "none",
    stroke: "#085488",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,24.955a8.466,8.466,0,0,0,6.515-2.47l5-5a8.485,8.485,0,0,0,0-12h0a8.485,8.485,0,0,0-12,0l-5,5A8.466,8.466,0,0,0,23.045,17",
    fill: "none",
    stroke: "#085488",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("line", {
    "data-color": "color-2",
    x1: 16,
    y1: 32,
    x2: 32,
    y2: 16,
    fill: "none",
    stroke: "#085488",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "miter"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlDownload);
export default __webpack_public_path__ + "static/media/url-download.1f53d22579fe0a667c4ad32f4be0462d.svg";
export { ForwardRef as ReactComponent };